// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  --zoom: 1;
}
@media (height < 770px) {
  :host {
    --zoom: 0.9;
  }
}

ion-content {
  --background: var(--ion-color-primary);
}
@media (min-width: 991px) {
  ion-content {
    --background: var(--ion-color-primary);
  }
}

.content-row {
  height: 100%;
}
.content-row .content-col {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0 35px;
}

.brand-logo {
  height: 22vh;
  width: 100%;
  margin-bottom: 30px;
  zoom: var(--zoom);
}

.card {
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: var(--radius-default);
  padding: 20px 17px;
  margin: 10px auto 20px;
  min-width: 300px;
  max-width: 375px;
  text-align: center;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1019607843);
  border: 1px solid #caded9;
}
@media (height < 770px) {
  .card {
    padding: 10px 20px;
  }
}
.card .cocktail-block {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  margin-bottom: 18px;
  zoom: var(--zoom);
}
.card .cocktail-block .cocktail {
  height: 20px;
  width: 20px;
}
.card .cocktail-block .cocktail-text {
  font-family: AppFont;
  font-size: 14px;
  line-height: 135%;
  text-align: center;
  text-wrap: balance;
}

ion-footer {
  zoom: var(--zoom);
  --background: transparent;
  background: transparent;
  overflow: hidden;
  position: absolute;
  bottom: 0;
  box-shadow: none;
  --box-shadow: none;
}

.footer-lang {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  max-width: max-content;
  margin: 0 auto;
  border-radius: var(--bg-radius);
  border: 1px solid #c0c0bf;
  padding: 3px;
  background: #fefbf5;
}
.footer-lang div {
  height: 44px;
  width: 84px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border-radius: 80px;
}
.footer-lang div p {
  font-family: AppFontMedium;
  font-size: 14px;
  line-height: 135%;
  letter-spacing: 0.02em;
  text-align: center;
  vertical-align: middle;
  text-transform: uppercase;
  color: #2b2820;
}
.footer-lang div ion-icon {
  height: 23px;
  width: 23px;
  border-radius: 50px;
  overflow: hidden;
  margin-right: 4.5px;
}
.footer-lang div.selected {
  background: var(--ion-color-tertiary);
  border-color: var(--ion-color-tertiary);
}
.footer-lang div.selected p {
  color: var(--color-white);
}
.footer-lang div.selected ion-icon {
  border: 1px solid var(--color-white);
}

.lang-block {
  padding-bottom: 25px;
}

.title,
.info-text {
  zoom: var(--zoom);
  font-family: AppFont;
  font-size: 14px;
  line-height: 135%;
  text-align: center;
  margin-bottom: 16px;
  color: var(--color-black);
}

.info-text {
  margin-top: 16px;
  margin-bottom: 4px;
}

.payment-block {
  zoom: var(--zoom);
  padding-block: 12px;
  border-top: 0.5px solid rgba(69, 73, 78, 0.5333333333);
  border-bottom: 0.5px solid rgba(69, 73, 78, 0.5333333333);
  margin-bottom: 16px;
}
.payment-block .payment-info {
  font-family: AppFontMedium;
  font-size: 10px;
  line-height: 135%;
  text-align: center;
  vertical-align: middle;
  margin-bottom: 12px;
  letter-spacing: -0.03em;
  color: var(--color-grey);
}
.payment-block .payment-icons {
  width: 100%;
  height: 16px;
}

.alergen-link {
  padding-bottom: 12px;
  cursor: pointer;
  margin-left: 10px;
  font-family: AppFontMedium;
  font-size: 14px;
  line-height: 120%;
  text-align: center;
  color: var(--color-grey);
  text-align: center;
  text-decoration: underline;
  text-decoration-style: solid;
  text-decoration-thickness: 10%;
  text-underline-offset: 2px;
  margin-left: 10px;
}

.subtitle {
  display: block;
  font-family: AppFontSemiBold;
  font-size: 24px;
  color: #1d1d1b;
  margin-bottom: 8px;
  text-wrap: balance;
  padding-block: 8px;
  margin-bottom: 10px;
}
@media (height < 770px) {
  .subtitle {
    font-size: 12px;
  }
}

.title-box {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
}
.title-box ion-icon {
  width: 32px;
  height: 32px;
  min-width: 32px;
  min-height: 32px;
  margin-top: 10px;
  position: relative;
}

.preorder-title {
  font-family: AppFont;
  font-size: 16px;
  font-weight: 500;
  color: #1d1d1b;
}
@media (height < 770px) {
  .preorder-title {
    font-size: 14px;
  }
}

@media (height < 770px) {
  .btn {
    height: 40px !important;
  }
}

.pointer {
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/home/home.page.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACC,SAAA;AADD;AAEC;EAFD;IAGE,WAAA;EACA;AACF;;AAEA;EACC,sCAAA;AACD;ACVE;EDQF;IAGE,sCAAA;EAGA;AACF;;AAEA;EACC,YAAA;AACD;AACC;EACC,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AACF;;AAGA;EACC,YAAA;EACA,WAAA;EACA,mBAAA;EACA,iBAAA;AAAD;;AAGA;EACC,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,oCAAA;EACA,kBAAA;EACA,sBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,uDAAA;EACA,yBAAA;AAAD;AAEC;EAbD;IAcE,kBAAA;EACA;AACF;AACC;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,iBAAA;AACF;AACE;EACC,YAAA;EACA,WAAA;AACH;AAEE;EACC,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EAEA,kBAAA;AADH;;AAMA;EACC,iBAAA;EACA,yBAAA;EACA,uBAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,gBAAA;EACA,kBAAA;AAHD;;AAKA;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,sBAAA;EACA,cAAA;EACA,+BAAA;EACA,yBAAA;EACA,YAAA;EACA,mBAAA;AAFD;AAIC;EACC,YAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;AAFF;AAIE;EACC,0BAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;AAFH;AAIE;EACC,YAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;AAFH;AAKE;EACC,qCAAA;EACA,uCAAA;AAHH;AAKG;EACC,yBAAA;AAHJ;AAMG;EACC,oCAAA;AAJJ;;AAUA;EACC,oBAAA;AAPD;;AAUA;;EAEC,iBAAA;EACA,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;AAPD;;AASA;EACC,gBAAA;EACA,kBAAA;AAND;;AASA;EACC,iBAAA;EACA,mBAAA;EACA,sDAAA;EACA,yDAAA;EACA,mBAAA;AAND;AAQC;EACC,0BAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,wBAAA;AANF;AASC;EACC,WAAA;EACA,YAAA;AAPF;;AAUA;EACC,oBAAA;EACA,eAAA;EACA,iBAAA;EAEA,0BAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EAEA,wBAAA;EACA,kBAAA;EACA,0BAAA;EACA,4BAAA;EACA,8BAAA;EACA,0BAAA;EACA,iBAAA;AATD;;AAYA;EACC,cAAA;EACA,4BAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;AATD;AAWC;EAVD;IAWE,eAAA;EARA;AACF;;AAWA;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;AARD;AAUC;EACC,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;AARF;;AAYA;EACC,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AATD;AAWC;EAND;IAOE,eAAA;EARA;AACF;;AAYC;EADD;IAEE,uBAAA;EARA;AACF;;AAWA;EACC,eAAA;AARD","sourcesContent":["@use '../../../theme/mixins' as *;\n\n:host {\n\t--zoom: 1;\n\t@media (height < 770px) {\n\t\t--zoom: 0.9;\n\t}\n}\n\nion-content {\n\t--background: var(--ion-color-primary);\n\t@include desktop {\n\t\t--background: var(--ion-color-primary);\n\t}\n}\n\n\n\n.content-row {\n\theight: 100%;\n\n\t.content-col {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tpadding: 0 35px;\n\t}\n}\n\n.brand-logo {\n\theight: 22vh;\n\twidth: 100%;\n\tmargin-bottom: 30px;\n\tzoom: var(--zoom);\n}\n\n.card {\n\tdisplay: flex;\n\tflex-direction: column;\n\tbackground: #fff;\n\tborder-radius: var(--radius-default);\n\tpadding: 20px 17px;\n\tmargin: 10px auto 20px;\n\tmin-width: 300px;\n\tmax-width: 375px;\n\ttext-align: center;\n\tbox-shadow: 0px 2px 8px 0px #0000001a;\n\tborder: 1px solid #caded9;\n\n\t@media (height < 770px) {\n\t\tpadding: 10px 20px;\n\t}\n\n\t.cocktail-block {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tgap: 8px;\n\t\tmargin-bottom: 18px;\n\t\tzoom: var(--zoom);\n\n\t\t.cocktail {\n\t\t\theight: 20px;\n\t\t\twidth: 20px;\n\t\t}\n\n\t\t.cocktail-text {\n\t\t\tfont-family: AppFont;\n\t\t\tfont-size: 14px;\n\t\t\tline-height: 135%;\n\t\t\ttext-align: center;\n\n\t\t\ttext-wrap: balance;\n\t\t}\n\t}\n}\n\nion-footer {\n\tzoom: var(--zoom);\n\t--background: transparent;\n\tbackground: transparent;\n\toverflow: hidden;\n\tposition: absolute;\n\tbottom: 0;\n\tbox-shadow: none;\n\t--box-shadow: none;\n}\n.footer-lang {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tgap: 12px;\n\tmax-width: max-content;\n\tmargin: 0 auto;\n\tborder-radius: var(--bg-radius);\n\tborder: 1px solid #c0c0bf;\n\tpadding: 3px;\n\tbackground: #fefbf5;\n\n\tdiv {\n\t\theight: 44px;\n\t\twidth: 84px;\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tcursor: pointer;\n\t\tborder-radius: 80px;\n\n\t\tp {\n\t\t\tfont-family: AppFontMedium;\n\t\t\tfont-size: 14px;\n\t\t\tline-height: 135%;\n\t\t\tletter-spacing: 0.02em;\n\t\t\ttext-align: center;\n\t\t\tvertical-align: middle;\n\t\t\ttext-transform: uppercase;\n\t\t\tcolor: #2b2820;\n\t\t}\n\t\tion-icon {\n\t\t\theight: 23px;\n\t\t\twidth: 23px;\n\t\t\tborder-radius: 50px;\n\t\t\toverflow: hidden;\n\t\t\tmargin-right: 4.5px;\n\t\t}\n\n\t\t&.selected {\n\t\t\tbackground: var(--ion-color-tertiary);\n\t\t\tborder-color: var(--ion-color-tertiary);\n\n\t\t\tp {\n\t\t\t\tcolor: var(--color-white);\n\t\t\t}\n\n\t\t\tion-icon {\n\t\t\t\tborder: 1px solid var(--color-white);\n\t\t\t}\n\t\t}\n\t}\n}\n\n.lang-block {\n\tpadding-bottom: 25px;\n}\n\n.title,\n.info-text {\n\tzoom: var(--zoom);\n\tfont-family: AppFont;\n\tfont-size: 14px;\n\tline-height: 135%;\n\ttext-align: center;\n\tmargin-bottom: 16px;\n\tcolor: var(--color-black);\n}\n.info-text {\n\tmargin-top: 16px;\n\tmargin-bottom: 4px;\n}\n\n.payment-block {\n\tzoom: var(--zoom);\n\tpadding-block: 12px;\n\tborder-top: 0.5px solid #45494e88;\n\tborder-bottom: 0.5px solid #45494e88;\n\tmargin-bottom: 16px;\n\n\t.payment-info {\n\t\tfont-family: AppFontMedium;\n\t\tfont-size: 10px;\n\t\tline-height: 135%;\n\t\ttext-align: center;\n\t\tvertical-align: middle;\n\t\tmargin-bottom: 12px;\n\t\tletter-spacing: -0.03em;\n\t\tcolor: var(--color-grey);\n\t}\n\n\t.payment-icons {\n\t\twidth: 100%;\n\t\theight: 16px;\n\t}\n}\n.alergen-link {\n\tpadding-bottom: 12px;\n\tcursor: pointer;\n\tmargin-left: 10px;\n\n\tfont-family: AppFontMedium;\n\tfont-size: 14px;\n\tline-height: 120%;\n\ttext-align: center;\n\n\tcolor: var(--color-grey);\n\ttext-align: center;\n\ttext-decoration: underline;\n\ttext-decoration-style: solid;\n\ttext-decoration-thickness: 10%;\n\ttext-underline-offset: 2px;\n\tmargin-left: 10px;\n}\n\n.subtitle {\n\tdisplay: block;\n\tfont-family: AppFontSemiBold;\n\tfont-size: 24px;\n\tcolor: #1d1d1b;\n\tmargin-bottom: 8px;\n\ttext-wrap: balance;\n\tpadding-block: 8px;\n\tmargin-bottom: 10px;\n\n\t@media (height < 770px) {\n\t\tfont-size: 12px;\n\t}\n}\n\n.title-box {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tmargin-bottom: 10px;\n\n\tion-icon {\n\t\twidth: 32px;\n\t\theight: 32px;\n\t\tmin-width: 32px;\n\t\tmin-height: 32px;\n\t\tmargin-top: 10px;\n\t\tposition: relative;\n\t}\n}\n\n.preorder-title {\n\tfont-family: AppFont;\n\tfont-size: 16px;\n\tfont-weight: 500;\n\tcolor: #1d1d1b;\n\n\t@media (height < 770px) {\n\t\tfont-size: 14px;\n\t}\n}\n\n.btn {\n\t@media (height < 770px) {\n\t\theight: 40px !important;\n\t}\n}\n\n.pointer {\n\tcursor: pointer;\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
